export default "__VITE_ASSET__BupSeVJG__"